import { Grid, Typography } from "@mui/material"
import { useForm } from "react-hook-form"
import { InputComponent } from "../../components/input"
import { LoadingButton } from "@mui/lab"
import { useState } from "react"
import { AuthService } from "../../services/auth"
import { useNavigate, useSearchParams } from "react-router-dom"
import { usePageTitle } from "../../hooks"

export const RedefinePassword = () => {
    usePageTitle("Redefinir senha")

    type HookFormData = { password: string, confirmPassword: string }

    const {
        register,
        watch,
        handleSubmit,
        formState: { errors },
        setValue,
    } = useForm<HookFormData>()

    const [loading, setLoading] = useState(false)

    const [searchParams] = useSearchParams()
    const navigate = useNavigate()

    const token = searchParams.get('t')
    const userId = searchParams.get('u')
    const role = searchParams.get('r')

    const savePassword = ({
        password
    }: HookFormData) => {
        setLoading(true)

        AuthService.redefinePassword({
            password: password,
            token: token as string,
            userId: userId as string,
            role: Number(role)
        })
            .then(() => navigate(Number(role) === 5 ? "/cliente" : "/parceiro"))
            .finally(() => {
                setLoading(false)
            })
    }

    if (!token || !userId || !role) {
        return (
            <Grid
                sx={{
                    height: "calc(100% - 80px)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <Typography variant="body2" textAlign={"center"} width={"70%"} sx={{ opacity: 0.5 }}>Você não tem permissão para acessar essa página</Typography>
            </Grid>
        )
    }

    return (
        <Grid
            container
            sx={{
                height: "calc(100% - 80px)",
                display: "flex",
                gap: "2.5rem",
                flexDirection: "column",
                alignItems: "center",
                paddingBottom: "20px",
                flexWrap: "nowrap"
            }}
        >

            <Typography
                variant="h1"
                textAlign={"left"}
                width={"90%"}
                mb={2}
            >Redefinir senha</Typography>

            <Grid
                sx={{
                    width: "100%",
                    display: "flex",
                    gap: "1.5rem",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <InputComponent
                    autoFocus
                    label="Nova senha"
                    value={watch("password") || ""}
                    onChangeValue={(value) => setValue("password", value, { shouldValidate: true })}
                    error={!!errors.password}
                    helperText={errors.password?.message}
                    {...register("password", {
                        required: {
                            value: true,
                            message: "Informe uma senha",
                        },
                        minLength: {
                            value: 4,
                            message: "A senha deve conter no mínimo 4 dígitos"
                        }
                    })}
                />

                <InputComponent
                    label="Confirmar senha"
                    value={watch("confirmPassword") || ""}
                    onChangeValue={(value) => setValue("confirmPassword", value, { shouldValidate: true })}
                    error={!!errors.confirmPassword}
                    helperText={errors.confirmPassword?.message}
                    {...register("confirmPassword", {
                        required: {
                            value: true,
                            message: "Confirme a senha",
                        },
                        validate: (value) => {
                            if (value !== watch("password")) return "A senha não coincide"
                        }
                    })}
                />

            </Grid>

            <LoadingButton
                variant="contained"
                loading={loading}
                onClick={(handleSubmit(savePassword))}
            >
                Alterar senha
            </LoadingButton>

        </Grid>
    )
}